import {useAppDispatch} from "config/store";
import {adminActions} from "config/store/modules/admin.ts";
import {useNavigate} from "react-router-dom";
import AdminConnectedContainer from "components/container/AdminConnectedContainer.tsx";
import {useTranslation} from "react-i18next";
import {tryAsyncFunc} from "globals/functions/async.ts";
import ajax from "config/ajax.ts";
import LoadingContainer from "components/container/LoadingContainer.tsx";
import {Form, Formik} from "formik";
import Button from "components/atom/button/Button.tsx";
import {EventFormValuesType} from "utils/form.ts";
import AdminEventForm from "components/layouts/form/AdminEventForm.tsx";
import {useMount} from "react-use";
import dayjs from "dayjs";

function AdminCreateEventPage() {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    useMount(() => {
        dispatch(adminActions.getUsers())
    })

    const values: EventFormValuesType = {
        active: true,
        titleFr: '',
        titleEn: '',
        descriptionFr: '',
        descriptionEn: '',
        address: '',
        city: '',
        zipcode: '',
        state: 'QC',
        country: 'CA',
        price: '',
        website: '',
        phoneNumber: '',
        externalLink: '',
        categoryId: null,
        latitude: null,
        longitude: null,
        creatorId: null,
        recurring: null,
        dates: [
            {
                startDate: dayjs()
                    .add(1, 'day')
                    .add(1, 'hour')
                    .set('minute', 0)
                    .set('second', 0)
                    .set('millisecond', 0)
                    .format('YYYY-MM-DD HH:mm:ss'),
                endDate: dayjs()
                    .add(1, 'day')
                    .add(2, 'hour')
                    .set('minute', 0)
                    .set('second', 0)
                    .set('millisecond', 0)
                    .format('YYYY-MM-DD HH:mm:ss')
            }
        ],
        images: []
    }

    return (
        <AdminConnectedContainer title={t('event.create')}>
            <div className="w-full">
                <Formik
                    initialValues={values}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validate={values => {
                        const errors: Partial<{ [K in keyof EventFormValuesType]: string }> = {};//same keys as type but with string value
                        if (!values.titleFr) {
                            errors.titleFr = t('forms.errors.requiredTitleFr')
                        }
                        return errors;
                    }}
                    onSubmit={async (values, {setSubmitting, setStatus, setFieldError}) => {
                        setSubmitting(true);
setStatus(null);

                        const [res, err] = await tryAsyncFunc(ajax.post(`/connected/admin/events`, values))
                        setSubmitting(false);

                        if (err) {
                            const errData = err.response.data || {}
                            const errors = errData.errors || {}

                            if (errors.global) {
                                setStatus(errors.global)
                                delete errors.global
                            }

                            Object.keys(errors).forEach(errKey => {
                                setFieldError(errKey, errors[errKey])
                            })
                            return
                        }

                        await dispatch(adminActions.createdEvent(res.data.event))
                        navigate(`/profile/admin/events/${res.data.event.uuid}`)
                    }}
                >
                    {({isSubmitting, status}) => (
                        <LoadingContainer isLoading={isSubmitting} keepChildren>
                            <Form>
                                <AdminEventForm/>

                                {status && (
                                    <p className="error block">{status}</p>
                                )}
                                <div className="mt-4 flex w-full flex-col items-center justify-center gap-4">
                                    <Button className="w-full" type="submit" disabled={isSubmitting}>
                                        {t('publish')}
                                    </Button>
                                </div>
                            </Form>
                        </LoadingContainer>
                    )}
                </Formik>

            </div>
        </AdminConnectedContainer>
    )
}

export default AdminCreateEventPage
